import utils from "../utils";
// import fullpage from "fullpage.js/dist/fullpage.extensions";
import fullpage from "fullpage.js";
import animations from "./animations.js";
// import dragAndMoveExtension from '../../../js/fullpage.dragAndMove.min.js';
//import lazyload from './lazy-load';

function twoDigit(d) {
    return (d < 10) ? '0' + d.toString() : d.toString();
}

function init() {

    if( document.getElementById("fullpage") ){

        const scrolling_speed = 1000;
        const totalSlides = document.querySelectorAll('.section').length;
        const background = document.querySelector('.main-bkg-image');
        const bg_per_page = 20;
        background.style.height = 100 + (totalSlides * bg_per_page) + 'vh';

        let navigationSteps = [];

        for (let i = 1; i < totalSlides+1; i++) {
            navigationSteps.push(twoDigit(i));
        }

        new fullpage("#fullpage", { // eslint-disable-line
            css3: true,
            // extensions: [dragAndMoveExtension],
            licenseKey: "S47L9-M01EH-KHXIH-CH967-MLYKN",
            dragAndMoveKey: 'cjZZbUZuWm5Wc0xtbDBJT18xNGRaSEpoWjBGdVpFMXZkbVU9Q1k2',
            dragAndMove: true,
            scrollBar: false,
            scrollOverflow: false,
            scrollingSpeed: scrolling_speed,
            easingcss3: 'ease-in-out',

            navigation: true,
            navigationPosition: 'right',
            navigationTooltips: navigationSteps,
            showActiveTooltip: true,
            
            afterRender: function(){

                var body = document.querySelector('body');

                body.classList.add('fullpage-loaded');
                fullpage_api.setAllowScrolling(false); // eslint-disable-line

                setTimeout(function() {
                    
                    fullpage_api.moveSectionDown(); // eslint-disable-line
                    fullpage_api.setAllowScrolling(true); // eslint-disable-line

                }, scrolling_speed + 200);

            },

			afterLoad: function(origin, destination, direction, trigger){ // eslint-disable-line

                var header = document.getElementById('smx-wrapper-navbar'),
                    navigations = document.querySelectorAll('#fp-nav li');

                if(navigations.length > 0){
                    utils.forEach(navigations, function (index, navigation) {
                        var active = navigation.querySelector('.active');
                        if(active){
                            navigation.classList.add('active');
                        } else {
                            navigation.classList.remove('active');
                        }
                    });
                }

                if(destination.index == 1){
                    header.classList.remove('hide');
                }

                if( origin.item.classList.contains('smx-box-composition') ){
                    animations.smxBoxCompositionAnimation('leave');
                }




                if(destination.item.classList.contains('flex-text-image')){

                    var lineWrapper = destination.item.querySelectorAll('.line-wrapper');

                    if(lineWrapper.length > 0){
                        utils.forEach(lineWrapper, function (index, elem) {
                            elem.classList.add('active');
                        });
                    }

                    setTimeout(function() {
                        
                        var fadeElems = destination.item.querySelectorAll('.fade-animation');

                        if(fadeElems.length > 0){
                            utils.forEach(fadeElems, function (index, elem) {
                                elem.classList.add('active');
                            });
                        }

                    }, 100);

                }else if( destination.item.classList.contains('smx-box-composition') ){
                    animations.smxBoxCompositionAnimation('enter');

                    var fadeElems = destination.item.querySelectorAll('.fade-animation');

                    if(fadeElems.length > 0){
                        utils.forEach(fadeElems, function (index, elem) {
                            elem.classList.add('active');
                        });
                    }

                } else {

                    var fadeElems = destination.item.querySelectorAll('.fade-animation'); // eslint-disable-line

                    if(fadeElems.length > 0){
                        utils.forEach(fadeElems, function (index, elem) {
                            elem.classList.add('active');
                        });
                    }

                }

            },

            beforeLeave: function(origin, destination, direction, trigger){ // eslint-disable-line

                background.style.transform = "translateY(-" + (destination.index * bg_per_page) + "vh)";

                if(destination.item.classList.contains('flex-text-image')){
                    var sliding_title = destination.item.querySelector('.sliding-title');
                    sliding_title.classList.add('visibile');
                    sliding_title.classList.remove('exit');
                }

                if(origin.item.classList.contains('flex-text-image')){
                    var sliding_title = origin.item.querySelector('.sliding-title'); // eslint-disable-line
                    sliding_title.classList.remove('visibile');
                    if(direction == 'down') {
                        sliding_title.classList.add('exit');
                    }
                }


                var actives = origin.item.querySelectorAll('.active');

                utils.forEach( actives, (index, elem) => {
                    elem.classList.remove('active');
                });



                if(direction == 'down'){
                    origin.item.classList.add('go-down');
                    destination.item.classList.remove('go-down');
                } else {
                    origin.item.classList.add('go-up');
                    destination.item.classList.remove('go-up');
                }

                /*

                var fullpageNav = document.getElementById('fullpage-navigations'),
                    totalSlides = document.querySelectorAll('.fp-section').length;

                if(destination.index == 0){
                    fullpageNav.querySelector('.up').classList.add('disabled');
                } else {
                    fullpageNav.querySelector('.up').classList.remove('disabled');
                }

                if(destination.index == (totalSlides - 1)){
                    fullpageNav.querySelector('.down').classList.add('disabled');
                } else {
                    fullpageNav.querySelector('.down').classList.remove('disabled');
                }
                */
                
                /*

                var bkgColor = window.getComputedStyle( destination.item, null).getPropertyValue('background-color');

                if(style.lightOrDark(bkgColor) == 'light' ){
                    header.classList.remove('on-dark-bkg');
                    header.classList.add('on-light-bkg');
                } else {
                    header.classList.remove('on-light-bkg');
                    header.classList.add('on-dark-bkg');
                }

                if(destination.index == 2){
                    destination.item.classList.add('section-is-loaded');
                }

                */

            },

        });
		

    }

}

window.moveSlide = function (direction){
    if(direction == 'down'){
        fullpage_api.moveSectionDown(); // eslint-disable-line
    } else {
        fullpage_api.moveSectionUp(); // eslint-disable-line
    }
}


export default {
	init,
};
